import { Options, Vue } from "vue-class-component";
import { gps } from "@/config/host.config";
import { IGpsData } from "@/@types/position/coordinates";
import { coordinates } from "@/store/modules/geoposition/coordinates";
import { AxiosResponse, AxiosError } from "axios";
import { AccessToken as token } from "@/api/accessDecoder";
import { isServerReachable } from "@/services/connectivity";
@Options({
  name: "coordinates",
})
export default class Coordinates extends Vue {
  gpsData = coordinates();
  gpsInterval!: ReturnType<typeof setTimeout>;

  mounted(): void {
    if (token.access) this.gpsCoordsDefinition();
  }

  beforeUnmount(): void {
    clearInterval(this.gpsInterval);
  }

  async getLocation(): Promise<IGpsData> {
    const url = gps.mainAPI;
    return new Promise((res, rej) => {
      this.$axios
        .get(url)
        .then((gps: AxiosResponse<IGpsData>) => {
          if (gps.status === 200) {
            res(gps.data);
          }
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  gpsCoordsDefinition(): void {
    this.gpsInterval = setInterval(() => {
      if (!token.isAuthorized) return;
      if (!isServerReachable()) return;
      this.getLocation()
        .then((location) => {
          this.gpsData.setCoordinates(location);
        })
        .catch((error) => {
          this.$error(error);
        });
    }, this.$second(1));
  }
}
